import gql from 'graphql-tag';

const createHtmlPreview = gql`
  mutation createHtmlPreview($shoppingCart: ShoppingCartInput!, $currentDocumentId: ID!) {
    generateDocumentHTMLPreview(shoppingCart: $shoppingCart, currentDocumentId: $currentDocumentId)
  }
`;

export default createHtmlPreview;
